import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { GenericConfirmationComponent } from 'src/app/components/dialog/generic-confirmation/generic-confirmation.component';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { FluxService } from 'src/app/service/flux-service';
import { ROUTES } from 'src/app/route/routes';
import { BookingService } from 'src/app/service/booking.service';
import { HomeService } from 'src/app/service/home.service';

@Component({
  selector: 'app-edit-booking',
  templateUrl: './edit-booking.component.html',
  styleUrls: ['./edit-booking.component.scss'],
  standalone: false
})
export class EditBookingComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  // isLoading: boolean = true;
  idReservation?: string;
  isEditable: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bookingService: BookingService,
    private homeService: HomeService,
    private dialog: MatDialog,
    private spinner: SpinnerService,
    private fluxService: FluxService
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.fluxService.initializeFromRoute(this.route);
    let reservationObject = this.homeService.getEditReservationObject();
    if (reservationObject && reservationObject.uuid_old_reservation) {
      this.idReservation = reservationObject.uuid_old_reservation;

      let eventObject = this.homeService.getEventObject();
      if (eventObject && eventObject.event_dates.length > 0) {
        this.isEditable = true;
      }

      this.spinner.hide();
    } else {
      this.goTo('home');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goTo(path: string) {
    const currentFlux = this.fluxService.getCurrentFlux();
    switch (path) {
      case 'reservations': {
        this.router.navigate([currentFlux + '/' + ROUTES.RESERVATION_LIST.path]);
        break;
      }

      case 'edit': {
        this.router.navigate([currentFlux + '/' + ROUTES.EVENT_CALENDAR.path]);
        break;
      }

      case 'delete': {
        this.spinner.show();
        this.bookingService.deleteReservation(this.idReservation!).subscribe({
          next: (res) => {
            this.router.navigate([currentFlux + '/' + ROUTES.EVENT_DELETE.path]);
          },
          error: (err) => {
            console.error(err);
            this.showError();
            this.spinner.hide();
          },
        });
        break;
      }

      case 'home': {
        this.router.navigate([ROUTES.HOME.path]);
        break;
      }
    }
  }

  showConfirmDelete(message?: string) {
    if (!message) message = 'edit_booking.confirm_delete';

    const dialogRef = this.dialog.open(GenericConfirmationComponent, {
      data: {
        isConfirmDialog: true,
        message: message,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.goTo('delete');
      }
    });
  }

  private showError(message?: string) {
    if (!message) message = 'edit_booking.show_error';

    const dialogRef = this.dialog.open(GenericConfirmationComponent, {
      data: {
        message: message,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.goTo('home');
    });
  }
}
